import { useEffect } from "react";
import { Link } from "react-router-dom";
import { HeaderLogo } from "@/components/Brand";

export default function NotFound() {
  useEffect(() => { document.title = "Page not found · LineGone"; }, []);
  return (
    <div className="min-h-screen bg-white" data-testid="not-found-page">
      <header className="flex h-14 items-center border-b border-line px-4"><HeaderLogo className="h-6" /></header>
      <main className="mx-auto max-w-md px-4 py-20 text-center">
        <div className="font-heading text-7xl font-black text-brand">404</div>
        <h1 className="mt-3 text-2xl font-black" data-testid="not-found-title">Not found</h1>
        <p className="mt-2 text-muted2">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn-primary mt-6 inline-flex" data-testid="not-found-home-link">Go to the home page</Link>
      </main>
    </div>
  );
}
